
/**
 * Original code from PerfectScrollbar: https://github.com/noraesae/perfect-scrollbar
 * Converted to es6 modules and made some compatibility changes
 */

import destroy from './plugin/destroy';
import initialize from './plugin/initialize';
import update from './plugin/update';

export default {
  initialize: initialize,
  update: update,
  destroy: destroy
};
